export const WITHDRAWAL_WIZARD_TYPES = {
  WIRE: 'wire ',
  CHECK: 'check',
};
export const WITHDRAWAL_PREFUNDED_WIZARD_TYPES = {
  WIRE: 'wire Transfer to Custodian',
  CHECK: 'check',
};
